import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/style-component/components/cardFormStyle.js";
import PropTypes from "prop-types";
import React from "react";
import { estilos } from "assets/jss/style-component/components/estiloComponente.js";

const useStyles = makeStyles(styles);

export default function CardHeaderForm(props) {
  const { className, children, color, plain, stats, icon, ...rest } = props;
  const cardHeaderClasses = estilos(useStyles(), props, "cardHeader");

  return (
    <div className={cardHeaderClasses} {...rest}>
      {children}
    </div>
  );
}

CardHeaderForm.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf([
    "warning",
    "success",
    "danger",
    "info",
    "primary",
    "rose",
    "cabecera"
  ]),
  plain: PropTypes.bool,
  stats: PropTypes.bool,
  icon: PropTypes.bool,
  children: PropTypes.node
};
